import styled from 'styled-components/macro';
import { FC } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { DPIconCircleRightArrow } from '../assets/icons';
import Typography from '../atoms/typography';
import Button from '../atoms/Button';
import media from '../constants/MediaQuery';
import Theme from '../constants/Theme';

const footerLinks = {
  quickLinks: [
    { label: 'About Us', link: '/about-us' },
    { label: 'Terms of Service', link: '/terms' },
    {
      label: 'Privacy',
      link: 'https://dotpay-registration-assets-images.s3.eu-central-1.amazonaws.com/DotPay+Terms+and+Conditions+(updated+final).docx.pdf',
    },
  ],
  contacts: {
    title: 'contact',
    items: [
      { name: 'hello@dotpay.africa', link: 'hello@dotpay.africa' },
      { name: '+2348061971534', link: 'tel:+2348061971534' },
      { name: '+2348061908723', link: 'tel:+2348061908723' },
    ],
  },
  socials: {
    title: 'socials',
    items: [
      { name: 'Instagram', link: 'https://www.instagram.com/dotpayafrica/' },
      { name: 'Twitter', link: 'https://twitter.com/DotPayAfrica/' },
      { name: 'LinkedIn', link: 'https://www.linkedin.com/company/dot-pay/' },
      { name: 'Facebook', link: 'https://www.facebook.com/dotpay.africa/' },
    ],
  },
  address: [
    { name: '366, Muritala Mohammed Way' },
    { name: 'MJS Building, (opposite Polaris bank),' },
    { name: 'Yaba Bus-stop,' },
    { name: 'Lagos State.' },
  ],
};

const Footer: FC = () => {
  const history = useHistory();
  return (
    <FS>
      <div className="Footer__FS__FS-container container">
        <div className="Footer__FS__footer-dotPay">
          <img className="logo" src="./assets/images/main-logo.svg" alt="dotpay" />
          <Typography.Text style={{ lineHeight: '27px' }} fontType="Galano Alt">
            Dotpay is team of amazing talents helping millions of underbanked Nigerians to access
            secure and convenient banking services. Write to us out the open roles we have
          </Typography.Text>
          <Button className="landing-btn" primary onClick={() => history.push('/contact-us')}>
            <Typography.Text uppercase weight="semiBold" level="xlarge">
              Send message
            </Typography.Text>
            <DPIconCircleRightArrow />
          </Button>
        </div>
        <div className="Footer__FS__footer-items">
          <div className="Footer__FS__footer-items--fc">
            <div className="Footer__FS__footer-items--footer-link">
              <Typography.Heading
                className="titles-subheadings"
                uppercase
                fontType="Galano Alt"
                color="darkBlue"
                weight="medium"
                level={1}>
                Links
              </Typography.Heading>
              <div className="Footer__FS__footer-items--footer-link--quickLinks">
                {footerLinks.quickLinks.map(({ label, link }, index) => (
                  <Typography.Text
                    key={index.toString()}
                    className="Footer__FS__footer-items--footer-link--quickLinks--lnks"
                    color="black"
                    uppercase
                    level="large"
                    fontType="Galano Alt">
                    {label !== 'Privacy' ? (
                      <Link to={link}>{label}</Link>
                    ) : (
                      <a href={link} target="_blank" rel="noreferrer">
                        {label}
                      </a>
                    )}
                  </Typography.Text>
                ))}
              </div>
            </div>
            <div className="Footer__FS__footer-items--other-link">
              <div style={{ marginBottom: '20px' }}>
                <Typography.Heading
                  className="titles-subheadings"
                  uppercase
                  fontType="Galano Alt"
                  color="darkBlue"
                  weight="medium"
                  level={1}>
                  {footerLinks.contacts.title}
                </Typography.Heading>
                {footerLinks.contacts.items.map(({ name, link }, index) => (
                  <Typography.Text
                    key={index.toString()}
                    className="Footer__FS__footer-items--other-link-- sl"
                    level="large"
                    fontType="Galano Alt">
                    <a href={link}>{name}</a>
                  </Typography.Text>
                ))}
              </div>
              <Typography.Heading
                className="titles-subheadings"
                uppercase
                fontType="Galano Alt"
                color="darkBlue"
                weight="medium"
                level={1}>
                {footerLinks.socials.title}
              </Typography.Heading>
              <div className="Footer__FS__footer-items--other-link--social-links">
                {footerLinks.socials.items.map(({ name, link }, index) => (
                  <Typography.Text
                    key={index.toString()}
                    className="Footer__FS__footer-items--other-link--social-links sl"
                    level="large"
                    fontType="Galano Alt">
                    <a href={link}>{name}</a>
                  </Typography.Text>
                ))}
              </div>
            </div>
            <div className="Footer__FS__footer-items--footer-address">
              <Typography.Heading
                className="titles-subheadings"
                uppercase
                fontType="Galano Alt"
                color="darkBlue"
                weight="medium"
                level={1}>
                Address
              </Typography.Heading>
              <div>
                {footerLinks.address.map(({ name }, index) => (
                  <Typography.Text
                    className="Footer__FS__footer-items--other-link-- sl"
                    key={index.toString()}
                    level="large"
                    fontType="Galano Alt">
                    {name}
                  </Typography.Text>
                ))}
              </div>
            </div>
          </div>
          <Typography.Text
            className="Footer__FS__footer-copyright"
            level="small"
            weight="normal"
            fontType="Galano">
            &copy; Dotpay {new Date().getFullYear()}. All Rights Reserved.
          </Typography.Text>
        </div>
      </div>
    </FS>
  );
};
const FS = styled.div`
  background: linear-gradient(#fbfbfb, #e4ffe1);
  padding-top: 100px;
  padding-bottom: 20px;

  ${media.smallDesktopMin` padding: 100px 0;`}
  .sl {
    font-size: ${Theme.fontSizes.regular};
    padding: 2px 0;
    @media screen and (min-width: 1024px) {
      font-size: ${Theme.fontSizes.large};
    }
  }

  .Footer__FS {
    &__FS-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      ${media.tabletMin` align-items: center;`}
      ${media.smallDesktopMin`
      flex-direction: row;
     justify-content: space-between;
     align-items: start;
     `};
    }

    &__footer-dotPay {
      margin-right: 0;
      width: 100%;
      //max-width: 318px;
      ${media.tabletMin`
      // margin-right: 40px;
      max-width: none;
      `};
      ${media.smallDesktopMin`
      margin-right: 40px;
      max-width: 318px;
      `};

      .landing-btn {
        margin-bottom: 0;
      }
    }

    &__footer-copyright {
      white-space: nowrap;
      display: flex;
      align-items: center;
      margin-top: 10px;

      &:before {
        content: '';
        width: 100%;
        height: 1px;
        background-color: ${Theme.colorPalette.textGrey};
        margin-right: 15px;
        ${media.tabletMin`display:block;`}
      }
    }

    &__footer-items {
      width: 100%;
      margin: 20px 0 0 0;

      ${media.smallDesktopMin`
           margin:0;
           max-width: 700px;
        `}
      &--fc {
        display: grid;
        grid-template-columns: 1fr 1fr;
        ${media.tabletMin`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
         margin: 40px 0 20px 0;
          > div: nth-child(1){
            // margin: 0 100px 0 0;
          }
      `}
        ${media.smallDesktopMin`margin: 0px 0 63px 0;`};
      }

      &--footer-link {
        &--quickLinks {
          display: flex;
          flex-direction: column;

          ${media.smallDesktopMin`
           flex-direction: column;
        `}
          &--lnks {
            padding: 10px 0 10px 0;
            font-size: ${Theme.fontSizes.large};
            &:hover {
              text-decoration: underline;
            }
            ${media.tabletMin`
            padding: 10px 0 10px;
          `}
          }
        }
      }

      &--footer-address {
        margin: 30px 0 0 0;
        ${media.tabletMin` margin: 0;`};
      }

      &--other-link {
        &--fc-links {
          font-size: ${Theme.fontSizes.large};
          padding: 10px 0;
        }

        &--social-links {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 5px;
          cursor: pointer;
          width: 100%;
          max-width: 100px;
          a:hover {
            text-decoration: underline;
          }
          ${media.smallDesktopMin`
         display: grid;
         grid-template-columns: 1fr 1fr;
         row-gap: 5px;
         column-gap: 10px;
        `};
        }
      }
    }
  }
`;
export default Footer;
